import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { HttpModule } from "@angular/http";
import { config } from "../../config";

@Injectable()
export class LicenseService {
  constructor(private httpClient: HttpClient) {}
  baseUrl = config.apiUrl;
  getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    return headers;
  }
  // getBillingShippingDetail(SalesOrderNo):Observable<any>{
  //     const params = new HttpParams().set('$filter', `number eq '${SalesOrderNo}'`);
  //     return this.httpClient.get(this.envService.microsoftBusinessApiUrl+"shippingandbilling",{params:params,headers:this.getHeaders()}).map((response)=>{
  //         console.log("inside license service")
  //         return response;
  //     })
  // }

  //getLicensePortalProducts
  getLicensePortalProducts(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "ReleaseManagement/v2/GetLicensePortalProducts", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  //get license product by product code

  getLicensePortalProductByProductCode(productCode): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ReleaseManagement/v2/GetLicensePortalProductByProductCode?productCode=" +
          productCode,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //Customer billing shipping
  getBillingShippingDetail(salesOrderNo): Observable<any> {
    //from MAS 90
    return this.httpClient
      .get(
        this.baseUrl +
          "CustomerBillingShipping/getBillingShippingDetails?salesOrderNo=" +
          salesOrderNo
      )
      .map((response) => {
        return response;
      });
  }
  addBillingShippingDetail(billingSHippingDetail): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "CustomerBillingShipping/addBillingShippingDetails",
        billingSHippingDetail
      )
      .map((response) => {
        return response;
      });
  }
  getAllCustomersDetail(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "CustomerBillingShipping/getAllCustomersDetail", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  //Service 360

  getService360LicenseDisplayDetail(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "Service360LicenseDetails/v3/GetService360LicenseDetails",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  generateService360License(
    service360LicensePurchaseDetail: any
  ): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "Service360LicenseDetails/v3/GenerateLicense",
        service360LicensePurchaseDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateService360License(service360LicenseUpdateDetail): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "Service360LicenseDetails/v3/UpdateLicense",
        service360LicenseUpdateDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  activateService360License(service360LicenseActivateDetail): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "Service360LicenseDetails/v3/ActivateLicense",
        service360LicenseActivateDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  viewService360ActivationHistory(licenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "Service360LicenseDetails/v3/ViewActivationHistory?LicenseId=" +
          licenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  deactiveService360License(
    service360LicenseDeactivateDetail
  ): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "Service360LicenseDetails/v3/DeActivateLicense",
        service360LicenseDeactivateDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //smartlink 360
  getSmartLinkDemoData(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "SmartLink360LicenseDetails/v3/GetDemoLicenseInfo", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getSmartLinkPurchaseLicenseDisplayDetail(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl + "SmartLink360LicenseDetails/v3/GetPurchaseLicenseInfo",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  generateSmartLink360License(
    smartLink360PurchaseLicenseDetail
  ): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "SmartLink360LicenseDetails/v3/GenerateLicense",
        smartLink360PurchaseLicenseDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateSmartLink360License(smartLink360UodateLicenseDetail): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "SmartLink360LicenseDetails/v3/UpdateLicense",
        smartLink360UodateLicenseDetail,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  viewSmartLink360ActivationHistory(LicenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "SmartLink360LicenseDetails/v3/ViewActivationHistory?LicenseId=" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  renewSmartLink360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "SmartLink360LicenseDetails/v3/RenewLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  viewSmartLink360RenewalHistory(LicenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "SmartLink360LicenseDetails/v3/getRenewalHistory/" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getUserFeedBackInfo(UserRegId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "SmartLink360LicenseDetails/v3/getUserFeedbackInfo?UserRegId=" +
          UserRegId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //advertisement
  getAllAdvertisement(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "LZ30AdvertisementDetails/v3/GetLZ30AdvertisementDetails",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  addAdvertisement(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "LZ30AdvertisementDetails/v3/AddLZ30AdvertisementDetails",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  deleteAdvertisement(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "LZ30AdvertisementDetails/v3/DeleteLZ30AdvertisementDetails",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateAdvertisement(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "LZ30AdvertisementDetails/v3/UpdateLZ30AdvertisementDetails",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateActiveInactiveAdvertisement(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "LZ30AdvertisementDetails/v3/ActiveDeActiveLZ30AdvertisementDetails",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //glt

  generateGltLicenseKey(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GLTLicenseDetails/generateLicenseKey", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  generateGltLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GLTLicenseDetails/generateGltLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getGltLicenseDetail(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "GLTLicenseDetails/getGltLicenseDetail", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  updateGltLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GLTLicenseDetails/updateGltLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  //LZ-30
  getLz30UserDeviceDisplayDetail(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "LZ30UserDetails/v2/GetLZ30UserDeviceDetails", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  addLz30Device(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "LZ30UserDetails/v2/AddLZ30Device", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  updateLz30Device(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "LZ30UserDetails/v2/UpdateLZ30Device", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getLz30PurchaseLicenseDisplayDetail(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl + "LZ30LicenseDetails/v3/GetLZ30LicensePurchaseDetails",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getAllLz30DeviceDetail(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "LZ30UserDetails/v2/GetLZ30DeviceDetail", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  extendLZ30TrialPeriod(data: any): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "LZ30UserDetails/v3/ExtendTrialPeriod", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  viewLZ30DeviceHistory(LZ30DeviceId, LZ30UserDetailId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "LZ30UserDetails/v3/GetLZ30DeviceHistory?LZ30DeviceId=" +
          LZ30DeviceId +
          "&LZ30UserDetailId=" +
          LZ30UserDetailId
      )
      .map((response) => {
        return response;
      });
  }
  purchaseLz30License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "LZ30LicenseDetails/v3/PurchaseLZ30License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getLZ30LicenseDetail(LZ30UserDeviceId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "LZ30LicenseDetails/v3/GetLZ30LicenseDetails?LZ30UserDeviceId=" +
          LZ30UserDeviceId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getLz30PurchaseHistory(LZ30UserDeviceId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "LZ30LicenseDetails/v3/GetLZ30PurchaseHistory?LZ30UserDeviceId=" +
          LZ30UserDeviceId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  addMoreLZ30License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "LZ30LicenseDetails/v3/AddMoreLZ30License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  //SCAL
  generateScalLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "ProductLicenseDetails/v3/GenerateLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getScalPurchaseLicenseDisplayDetails(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl + "ProductLicenseDetails/v3/GetLicensePurchaseDetails",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getScalCustomerLicenseDetail(LicenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductLicenseDetails/v3/GetLicenseDetailswithoutuser?LicenseId=" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateScalPurchaseLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "ProductLicenseDetails/v3/UpdateLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  activateScalLicense(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "ProductActivationDetails/v3/ConfirmGenerateActivationKey",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  addMoreScalLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "ProductPurchaseDetails/v3/AddMoreLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  viewScal360PurchaseHistory(LicenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductPurchaseDetails/v3/ViewPurchaseDetails?LicenseId=" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getScalCustomerLicenseDetailForActivationAndRenewal(
    LicenseId
  ): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductLicenseDetails/v3/GetLicenseDetailsandRenewalDetails?LicenseId=" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  renewScal360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "ProductRenewalDetails/v3/RenewLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getScal360CustomerLicenseDetail(LicenseId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductLicenseDetails/v3/getLicenseDetails?LicenseId=" +
          LicenseId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  viewScal360ActivationHistory(LicenseDetailId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductActivationDetails/v3/ViewActivationKey?LicenseDetailId=" +
          LicenseDetailId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  deleteScal360ActivationKey(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "ProductActivationDetails/v3/DeleteActivationKey",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getScalLicenseRenewalHistory(LicenseDetailId): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "ProductRenewalDetails/v3/GetRenewalLicense?LicenseDetailId=" +
          LicenseDetailId,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  deleteScalCustomerLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "ProductLicenseDetails/v3/DeleteLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  deleteParticularCustomerParticularLicense(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "ProductLicenseDetails/v2/DeleteParticularLicenseKey",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  viewScalDownloadReleaseHistory(LicenseKey): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "Operations/v2/ViewSCALDownloadHistory?LicenseKey=" +
          LicenseKey,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //SMART-CAL360N
  generatesmartcal360NLicenseKey(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "SmartCal360NLicenseDetail/v1/GenerateSmartCal360NLicenseKey",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  getSmartCal360NLicenseDetails(): Observable<any> {
    return this.httpClient
      .get(
        this.baseUrl +
          "SmartCal360NLicenseDetail/v1/GetSmartCal360NLicenceSerialDetails",
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  updateSmarCal360NLicense(data): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl + "SmartCal360NLicenseDetail/v1/UpdateSmartCal360NLicense",
        data,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  //FAQ
  addFAQ(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "Faq/v3/AddUpdateFAQ", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  getFAQWithProductId(productId): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "Faq/v3/getProductFAQ?ProductId=" + productId, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
  deleteFAQ(FAQId, UpdatedBy): Observable<any> {
    return this.httpClient
      .delete(
        this.baseUrl +
          "Faq/v3/DeleteFAQ?FAQId=" +
          FAQId +
          "&UpdatedBy=" +
          UpdatedBy,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }
  importFAQ(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "Faq/v3/importFAQ", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  //SyncIT

  getSyncItLicenseDetails(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "SyncIT/v2/getSyncITLicenseInfo", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getSyncITLicenseHistory(SyncItProductLicenseId): Observable<any> {
    return this.httpClient
      .get(
        `${this.baseUrl}SyncIT/v2/GetSyncITLicenseHistory/${SyncItProductLicenseId}`,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  getSyncITProducts(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "SyncIT/v2/getSyncITProduct", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  GenerateSyncITLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "SyncIT/v2/GenerateSyncITLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  GenerateGIS360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/GenerateGIS360License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  UpdateGIS360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/UpdateGIS360License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  RenewGIS360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/RenewGIS360License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  ActivateGIS360LicenseKey(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/ActivateGIS360LicenseKey", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  DeleteGIS360License(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/DeleteGIS360License", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  DeleteGIS360LicenseKey(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/DeleteGIS360LicenseKey", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getGIS360RenewalHistory(licenseKeyId): Observable<any> {
    const params = new HttpParams().set("licenseKeyId", licenseKeyId);
    return this.httpClient
      .get(this.baseUrl + "GIS360License/v2/GetGIS360RenewalHistory", {
        params: params,
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getGIS360ActivationDetails(licenseKeyId): Observable<any> {
    const params = new HttpParams().set("licenseKeyId", licenseKeyId);
    return this.httpClient
      .get(this.baseUrl + "GIS360License/v2/GetGIS360ActivationDetails", {
        params: params,
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  DeactivateGIS360Activation(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "GIS360License/v2/DeactivateGIS360Activation", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getGIS360LicenseList(): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + "GIS360License/v2/GetGIS360LicenseList", {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getGIS360LicenseKeys(licenseMasterId): Observable<any> {
    const params = new HttpParams().set("licenseMasterId", licenseMasterId);
    return this.httpClient
      .get(this.baseUrl + "GIS360License/v2/GetGIS360LicenseKeys", {
        params: params,
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  addBillingShippingDetailsSyncIT(billingSHippingDetail): Observable<any> {
    return this.httpClient
      .post(
        this.baseUrl +
          "CustomerBillingShipping/addBillingShippingDetailsSyncIT",
        billingSHippingDetail
      )
      .map((response) => {
        return response;
      });
  }

  ExtendTrialRenewPeriod(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "SyncIT/v2/ExtendTrialRenewPeriod", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  getSyncITLicensePurchaseProduct(SyncItproductLicenseId: number) {
    return this.httpClient
      .get(
        `${this.baseUrl}SyncIT/v2/getSyncITLicensePurchaseProduct?SyncItproductLicenseId=${SyncItproductLicenseId}`,
        { headers: this.getHeaders() }
      )
      .map((response) => {
        return response;
      });
  }

  addMoreSyncItLicense(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "SyncIT/v2/addMoreSyncItLicense", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }

  approveTrialPeriodExtension(data): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + "SyncIT/v2/ApproveTrialPeriodExtension", data, {
        headers: this.getHeaders(),
      })
      .map((response) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/LicenseService.ts